export interface Comic {
  id: string;
  slug: string;
  title: string;
  author: string;
  category: string;
  categorySlug: string;
  coverImage: string;
  description: string;
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  tags: string[];
  updateDate: string;
  chapters: Chapter[];
}

export interface Chapter {
  id: string;
  title: string;
  number: number;
  updateDate: string;
}

export interface Category {
  name: string;
  slug: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  { name: '韩漫', slug: 'hanman', icon: 'ri-earth-line', count: 128 },
  { name: '日漫', slug: 'riman', icon: 'ri-earth-line', count: 256 },
  { name: '国漫', slug: 'guoman', icon: 'ri-earth-line', count: 189 },
  { name: '耽美', slug: 'danmei', icon: 'ri-hearts-line', count: 95 },
  { name: '奇幻', slug: 'qihuan', icon: 'ri-magic-line', count: 143 },
  { name: '热血', slug: 'rexue', icon: 'ri-fire-line', count: 167 },
  { name: '恋爱', slug: 'lianai', icon: 'ri-heart-line', count: 203 },
  { name: '搞笑', slug: 'gaoxiao', icon: 'ri-emotion-laugh-line', count: 112 },
  { name: '悬疑', slug: 'xuanyi', icon: 'ri-search-eye-line', count: 78 },
  { name: '校园', slug: 'xiaoyuan', icon: 'ri-school-line', count: 134 },
];

export const comics: Comic[] = [
  {
    id: '1',
    slug: 'secret-class',
    title: '秘密教学',
    author: 'Swan',
    category: '韩漫',
    categorySlug: 'hanman',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20cover%2C%20two%20characters%20close-up%2C%20romantic%20drama%20mood%2C%20soft%20pink%20and%20warm%20lighting%2C%20Korean%20webtoon%20art%20style%2C%20clean%20simple%20background%20with%20subtle%20gradient%2C%20professional%20digital%20art%2C%20youth%20romance%20theme&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    description: '从小失去父母被收养的子豪，在养父母家长大成人。某天，他的生活中突然闯入了一个神秘的女孩，从此他平凡的人生开始发生翻天覆地的变化……一段青涩又充满诱惑的秘密教学就此展开。',
    status: '连载中',
    rating: 9.2,
    views: 1280000,
    tags: ['恋爱', '校园', '剧情'],
    updateDate: '2026-08-03',
    chapters: Array.from({ length: 120 }, (_, i) => ({
      id: `ch-1-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2026-${String(Math.max(1, Math.floor(Math.random() * 7) + 1)).padStart(2, '0')}-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: '2',
    slug: 'solo-leveling',
    title: '我独自升级',
    author: 'Chugong / DUBU',
    category: '韩漫',
    categorySlug: 'hanman',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20cover%2C%20solo%20hunter%20with%20dark%20aura%2C%20epic%20fantasy%20style%2C%20purple%20and%20black%20color%20scheme%2C%20dramatic%20lighting%2C%20Korean%20webtoon%20art%2C%20clean%20simple%20background%2C%20powerful%20character%20portrait&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    description: '十年前，世界各地出现了连接异次元的"门"，而门内觉醒的人类被称为"猎人"。身为E级猎人的成振宇，在某次突袭任务中意外获得了"系统"的力量，从此踏上独自升级之路！',
    status: '已完结',
    rating: 9.7,
    views: 3560000,
    tags: ['热血', '奇幻', '战斗'],
    updateDate: '2026-07-28',
    chapters: Array.from({ length: 179 }, (_, i) => ({
      id: `ch-2-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2026-${String(Math.max(1, Math.floor(Math.random() * 7) + 1)).padStart(2, '0')}-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: '3',
    slug: 'demon-slayer',
    title: '鬼灭之刃',
    author: '吾峠呼世晴',
    category: '日漫',
    categorySlug: 'riman',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20cover%20style%2C%20demon%20slayer%20with%20sword%2C%20traditional%20Japanese%20clothing%2C%20water%20breathing%20effect%2C%20blue%20and%20teal%20color%20palette%2C%20dynamic%20action%20pose%2C%20shonen%20manga%20art%2C%20clean%20simple%20background&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    description: '大正时代，卖炭少年炭治郎一家惨遭鬼的袭击。唯一幸存的妹妹祢豆子却变成了鬼，为了寻找让妹妹变回人类的方法，炭治郎踏上了成为鬼杀队剑士的征程！',
    status: '已完结',
    rating: 9.5,
    views: 2890000,
    tags: ['热血', '战斗', '奇幻'],
    updateDate: '2026-07-30',
    chapters: Array.from({ length: 205 }, (_, i) => ({
      id: `ch-3-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2026-${String(Math.max(1, Math.floor(Math.random() * 7) + 1)).padStart(2, '0')}-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: '4',
    slug: 'spy-family',
    title: '间谍过家家',
    author: '远藤达哉',
    category: '日漫',
    categorySlug: 'riman',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20family%20comedy%20cover%2C%20spy%20family%20portrait%2C%20father%20mother%20and%20child%20with%20dog%2C%20warm%20color%20palette%2C%20slice%20of%20life%20art%20style%2C%20clean%20simple%20beige%20background%2C%20wholesome%20and%20funny%20vibe&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    description: '为了执行秘密任务，顶级间谍"黄昏"需要组建一个临时家庭。他收养的女儿竟然是个超能力者，而妻子则是个职业杀手。三人互相隐藏身份，却组成了一个温馨有趣的非典型家庭。',
    status: '连载中',
    rating: 9.4,
    views: 2150000,
    tags: ['搞笑', '日常', '剧情'],
    updateDate: '2026-08-02',
    chapters: Array.from({ length: 98 }, (_, i) => ({
      id: `ch-4-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2026-${String(Math.max(1, Math.floor(Math.random() * 7) + 1)).padStart(2, '0')}-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: '5',
    slug: 'the-kings-avatar',
    title: '全职高手',
    author: '蝴蝶蓝',
    category: '国漫',
    categorySlug: 'guoman',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20esports%20cover%2C%20professional%20gamer%20with%20headset%2C%20futuristic%20gaming%20theme%2C%20golden%20and%20dark%20color%20scheme%2C%20Chinese%20digital%20art%20style%2C%20confident%20expression%2C%20clean%20simple%20background%2C%20competitive%20gaming%20vibe&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    description: '被誉为"荣耀教科书"的顶尖高手叶修，遭到俱乐部驱逐后，栖身于一家网吧重新开始。手持一把自制银武，在全新服务器中再攀荣耀巅峰！属于他的传奇，才刚刚开始。',
    status: '已完结',
    rating: 9.3,
    views: 1980000,
    tags: ['热血', '竞技', '剧情'],
    updateDate: '2026-07-25',
    chapters: Array.from({ length: 156 }, (_, i) => ({
      id: `ch-5-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2026-${String(Math.max(1, Math.floor(Math.random() * 7) + 1)).padStart(2, '0')}-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: '6',
    slug: 'heaven-officials-blessing',
    title: '天官赐福',
    author: '墨香铜臭',
    category: '国漫',
    categorySlug: 'guoman',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20fantasy%20cover%2C%20ancient%20Chinese%20immortal%20in%20flowing%20robes%2C%20ethereal%20celestial%20atmosphere%2C%20red%20and%20gold%20color%20scheme%2C%20traditional%20Chinese%20painting%20influence%2C%20romantic%20and%20mystical%2C%20clean%20simple%20background&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    description: '八百年前，谢怜是风光无限的仙乐太子。八百年后，他第三次飞升，却成了三界笑柄。在凡间，他遇到了一位神秘的红衣少年，一段跨越八百年的因缘，就此揭开帷幕。',
    status: '连载中',
    rating: 9.6,
    views: 2450000,
    tags: ['奇幻', '恋爱', '古风'],
    updateDate: '2026-08-01',
    chapters: Array.from({ length: 88 }, (_, i) => ({
      id: `ch-6-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2026-${String(Math.max(1, Math.floor(Math.random() * 7) + 1)).padStart(2, '0')}-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: '7',
    slug: 'jujutsu-kaisen',
    title: '咒术回战',
    author: '芥见下下',
    category: '日漫',
    categorySlug: 'riman',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20supernatural%20cover%2C%20sorcerer%20with%20dark%20energy%20effects%2C%20intense%20battle%20atmosphere%2C%20dark%20blue%20and%20red%20contrast%2C%20shonen%20manga%20art%20style%2C%20dramatic%20composition%2C%20clean%20simple%20background&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    description: '高中生虎杖悠仁偶然吞下了特级咒物"宿傩的手指"，成为了两面宿傩的容器。从此他被卷入咒术师与诅咒之间的残酷战斗，进入东京都立咒术高专，开始了与诅咒斗争的日常。',
    status: '连载中',
    rating: 9.1,
    views: 2760000,
    tags: ['热血', '奇幻', '战斗'],
    updateDate: '2026-08-03',
    chapters: Array.from({ length: 245 }, (_, i) => ({
      id: `ch-7-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2026-${String(Math.max(1, Math.floor(Math.random() * 7) + 1)).padStart(2, '0')}-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: '8',
    slug: 'lookism',
    title: '外貌至上主义',
    author: '朴泰俊',
    category: '韩漫',
    categorySlug: 'hanman',
    coverImage: 'https://readdy.ai/api/search-image?width=400&height=560&seq=comic-cover-08&orientation=portrait&query=Korean%20webtoon%20cover%2C%20split%20face%20concept%2C%20one%20side%20handsome%20one%20side%20ordinary%2C%20school%20life%20theme%2C%10modern%20Korean%20art%20style%2C%20dramatic%20lighting%20contrast%2C%20clean%20simple%20background',
    description: '胖墩高中生朴亨硕在学校遭受霸凌，无奈转学到首尔。一觉醒来，他发现自己拥有了另一副完美的身体！白天是帅气男神，晚上是平凡少年，双重身份的人生就此展开。',
    status: '连载中',
    rating: 8.9,
    views: 1890000,
    tags: ['校园', '剧情', '励志'],
    updateDate: '2026-08-02',
    chapters: Array.from({ length: 450 }, (_, i) => ({
      id: `ch-8-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2026-${String(Math.max(1, Math.floor(Math.random() * 7) + 1)).padStart(2, '0')}-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: '9',
    slug: 'to-your-eternity',
    title: '致不灭的你',
    author: '大今良时',
    category: '日漫',
    categorySlug: 'riman',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20philosophical%20cover%2C%20mysterious%20white%20orb%20transforming%2C%20ethereal%20and%20dreamlike%20atmosphere%2C%20soft%20white%20and%20grey%20tones%2C%20emotional%20and%20deep%20art%20style%2C%20clean%20simple%20background&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    description: '一个神秘的白色球体被投放到地球上，它能够幻化成世间万物。当它遇到一个少年后，获得了"不死"的名字和人的姿态。从此，一段跨越时空、探索生命意义的永恒之旅开始了。',
    status: '已完结',
    rating: 9.0,
    views: 980000,
    tags: ['奇幻', '剧情', '治愈'],
    updateDate: '2026-07-20',
    chapters: Array.from({ length: 175 }, (_, i) => ({
      id: `ch-9-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2026-${String(Math.max(1, Math.floor(Math.random() * 7) + 1)).padStart(2, '0')}-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: '10',
    slug: 'the-beginning-after-the-end',
    title: '三岁开始做王者',
    author: 'TurtleMe',
    category: '韩漫',
    categorySlug: 'hanman',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%2C%20young%20king%20with%20magic%20aura%2C%20medieval%20fantasy%20setting%2C%20royal%20blue%20and%20gold%20accents%2C%20reincarnation%20theme%2C%20Korean%20webtoon%20art%20style%2C%20clean%20simple%20background&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    description: '曾经统治世界的格雷国王，在毒杀后重生为婴儿亚瑟。带着前世的记忆和对魔法的理解，他决定这辈子要守护好身边的人。三岁的身体里住着成熟的灵魂，传奇故事就此开始。',
    status: '连载中',
    rating: 9.0,
    views: 1650000,
    tags: ['奇幻', '冒险', '重生'],
    updateDate: '2026-08-01',
    chapters: Array.from({ length: 175 }, (_, i) => ({
      id: `ch-10-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2026-${String(Math.max(1, Math.floor(Math.random() * 7) + 1)).padStart(2, '0')}-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: '11',
    slug: 'the-legendary-mechanic',
    title: '超神机械师',
    author: '齐佩甲',
    category: '国漫',
    categorySlug: 'guoman',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20sci-fi%20cover%2C%20mechanic%20with%20futuristic%20armor%2C%20space%20and%20robot%20theme%2C%20metallic%20silver%20and%20blue%20color%20scheme%2C%20Chinese%20digital%20art%20style%2C%20action%20pose%2C%20clean%20simple%20background&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    description: '韩萧穿越到了游戏《星海》的世界中，成为了一名机械师。凭借对游戏的理解，他在这个科幻世界中不断变强，从低级佣兵一步步成长为宇宙中的传奇机械师！',
    status: '连载中',
    rating: 8.8,
    views: 1350000,
    tags: ['科幻', '热血', '冒险'],
    updateDate: '2026-07-31',
    chapters: Array.from({ length: 200 }, (_, i) => ({
      id: `ch-11-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2026-${String(Math.max(1, Math.floor(Math.random() * 7) + 1)).padStart(2, '0')}-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: '12',
    slug: 'chainsaw-man',
    title: '电锯人',
    author: '藤本树',
    category: '日漫',
    categorySlug: 'riman',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20dark%20cover%2C%20chainsaw%20demon%20hybrid%20character%2C%20bloody%20and%20chaotic%20atmosphere%2C%20orange%20and%20black%20color%20scheme%2C%20unique%20manga%20art%20style%2C%20dramatic%20lighting%2C%20clean%20simple%20background&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    description: '少年淀治为了偿还亡父的债务，与恶魔啵奇塔一起做着恶魔猎人的工作。在一次背叛中被杀后，啵奇塔与他合体，让他重生为"电锯人"。从此被公安对魔特异课吸纳，开始了全新的生活。',
    status: '连载中',
    rating: 9.2,
    views: 2340000,
    tags: ['热血', '奇幻', '黑暗'],
    updateDate: '2026-08-03',
    chapters: Array.from({ length: 167 }, (_, i) => ({
      id: `ch-12-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2026-${String(Math.max(1, Math.floor(Math.random() * 7) + 1)).padStart(2, '0')}-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: '13',
    slug: 'who-made-me-a-princess',
    title: '某天成为公主',
    author: 'Plutus / Spoon',
    category: '韩漫',
    categorySlug: 'hanman',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20fantasy%20cover%2C%20princess%20in%20beautiful%20dress%2C%20royal%20palace%20background%20hint%2C%20pink%20and%20gold%20color%20scheme%2C%20shojo%20art%20style%2C%20elegant%20and%20dreamy%2C%20clean%20simple%20background&width=400&height=560&seq=comic-cover-13&orientation=portrait',
    description: '现代女性穿越成小说中注定死于父皇之手的公主。为了活命，她竭尽全力远离那个冷酷的皇帝父亲。然而越是躲避，这位父皇就越是对她产生了兴趣……一段惊心动魄的皇室生存记。',
    status: '已完结',
    rating: 9.1,
    views: 1780000,
    tags: ['恋爱', '奇幻', '穿越'],
    updateDate: '2026-07-15',
    chapters: Array.from({ length: 125 }, (_, i) => ({
      id: `ch-13-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2026-${String(Math.max(1, Math.floor(Math.random() * 7) + 1)).padStart(2, '0')}-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: '14',
    slug: 'spare-me-great-lord',
    title: '大王饶命',
    author: '会说话的肘子',
    category: '国漫',
    categorySlug: 'guoman',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comedy%20cover%2C%20young%20man%20with%20mischievous%20smile%2C%20modern%20urban%20fantasy%20theme%2C%20bright%20and%20colorful%20style%2C%20Chinese%20digital%20art%2C%20humorous%20tone%2C%20clean%20simple%20background&width=400&height=560&seq=comic-cover-14&orientation=portrait',
    description: '吕树在一次意外中觉醒了异能，从此走上了一条独特的修行之路。靠着收集别人的负面情绪值来提升实力，他一边吐槽一边变强，一路上笑料百出，成为令敌人闻风丧胆的存在。',
    status: '连载中',
    rating: 8.7,
    views: 1120000,
    tags: ['搞笑', '热血', '都市'],
    updateDate: '2026-07-29',
    chapters: Array.from({ length: 210 }, (_, i) => ({
      id: `ch-14-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2026-${String(Math.max(1, Math.floor(Math.random() * 7) + 1)).padStart(2, '0')}-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: '15',
    slug: 'kaiju-no-8',
    title: '怪兽8号',
    author: '松本直也',
    category: '日漫',
    categorySlug: 'riman',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20monster%20cover%2C%20human%20transforming%20into%20kaiju%2C%20military%20and%20monster%20theme%2C%20green%20and%20dark%20blue%20color%20scheme%2C%20action%20shonen%20art%20style%2C%20dynamic%20composition%2C%20clean%20simple%20background&width=400&height=560&seq=comic-cover-15&orientation=portrait',
    description: '32岁的中年清洁工日比野卡夫卡，梦想是加入防卫队与怪兽战斗。某天，他意外获得了变身怪兽的能力，被称为"怪兽8号"。以怪兽之身守护人类，他的第二人生正式启航！',
    status: '连载中',
    rating: 9.0,
    views: 1560000,
    tags: ['热血', '科幻', '战斗'],
    updateDate: '2026-08-01',
    chapters: Array.from({ length: 105 }, (_, i) => ({
      id: `ch-15-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2026-${String(Math.max(1, Math.floor(Math.random() * 7) + 1)).padStart(2, '0')}-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: '16',
    slug: 'tales-of-demons-and-gods',
    title: '妖神记',
    author: '发飙的蜗牛',
    category: '国漫',
    categorySlug: 'guoman',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cultivation%20cover%2C%20young%20cultivator%20with%20spiritual%20energy%2C%20ancient%20Chinese%20fantasy%20theme%2C%20golden%20and%20jade%20green%20color%20scheme%2C%20Chinese%20digital%20art%2C%20epic%20atmosphere%2C%20clean%20simple%20background&width=400&height=560&seq=comic-cover-16&orientation=portrait',
    description: '前世被挚爱背叛而死的聂离，重生回到了少年时代。带着前世的所有记忆和知识，他决心改变一切——守护心爱之人，对抗即将降临的灭世之灾，他要改写命运的轨迹！',
    status: '连载中',
    rating: 8.6,
    views: 1450000,
    tags: ['奇幻', '重生', '热血'],
    updateDate: '2026-07-30',
    chapters: Array.from({ length: 380 }, (_, i) => ({
      id: `ch-16-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2026-${String(Math.max(1, Math.floor(Math.random() * 7) + 1)).padStart(2, '0')}-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: '17',
    slug: 'omniscient-readers-viewpoint',
    title: '全知读者视角',
    author: 'sing N song / Sleepy-C',
    category: '韩漫',
    categorySlug: 'hanman',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20apocalyptic%20cover%2C%20reader%20facing%20fantasy%20world%2C%20dystopian%20and%20survival%20theme%2C%20dark%20and%20mysterious%20atmosphere%2C%20Korean%20webtoon%20art%2C%20intense%20expression%2C%20clean%20simple%20background&width=400&height=560&seq=comic-cover-17&orientation=portrait',
    description: '金独子是唯一一个读完了长达3149话网文《灭活法》的读者。当小说中的世界突然变成现实，凭借对剧情的全知，他成为了这个世界唯一的希望。但故事，似乎正在偏离他熟知的轨道……',
    status: '连载中',
    rating: 9.5,
    views: 2100000,
    tags: ['奇幻', '冒险', '剧情'],
    updateDate: '2026-08-03',
    chapters: Array.from({ length: 200 }, (_, i) => ({
      id: `ch-17-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2026-${String(Math.max(1, Math.floor(Math.random() * 7) + 1)).padStart(2, '0')}-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: '18',
    slug: 'daily-life-of-immortal-king',
    title: '仙王的日常生活',
    author: '枯玄',
    category: '国漫',
    categorySlug: 'guoman',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20school%20fantasy%20cover%2C%20student%20with%20hidden%20godly%20power%2C%20modern%20school%20with%20magic%20elements%2C%20bright%20and%20playful%20color%20scheme%2C%20Chinese%20digital%20art%2C%20comedy%20slice%20of%20life%2C%20clean%20simple%20background&width=400&height=560&seq=comic-cover-18&orientation=portrait',
    description: '王令是一名普通的高中生，但他其实是一名活了数千年的仙王。为了过上平凡的校园生活，他用一道符咒封印了自己的力量。然而，各路修仙者和妖魔鬼怪却总是找上门来……',
    status: '连载中',
    rating: 8.5,
    views: 1250000,
    tags: ['搞笑', '校园', '奇幻'],
    updateDate: '2026-07-28',
    chapters: Array.from({ length: 260 }, (_, i) => ({
      id: `ch-18-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2026-${String(Math.max(1, Math.floor(Math.random() * 7) + 1)).padStart(2, '0')}-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`,
    })),
  },
];

export const faqs = [
  {
    question: '汗汗漫画网是免费的吗？',
    answer: '是的，汗汗漫画网所有漫画内容完全免费！我们致力于为漫画爱好者提供免费的韩漫、日漫、国漫等各类漫画阅读服务。无需付费，无需会员，打开即可畅享热门漫画大全。',
  },
  {
    question: '什么是下拉式连续阅读模式？',
    answer: '下拉式连续阅读是汗汗漫画网的核心特色功能。用户只需向下滚动页面，漫画内容就会自动连续加载，无需频繁点击翻页。这种阅读方式模拟了手机端的流畅浏览体验，让在线看漫画更加顺畅不卡顿，沉浸感更强。',
  },
  {
    question: '支持哪些类型的漫画？',
    answer: '汗汗漫画网提供丰富的漫画分类，涵盖韩漫（韩国漫画）、日漫（日本漫画）、国漫（国产漫画）、耽美、奇幻、热血、恋爱、搞笑、悬疑、校园等主流类型。无论你喜欢什么风格的漫画，都能在这里找到心仪的作品。',
  },
  {
    question: '漫画更新频率如何？',
    answer: '我们拥有专业的漫画更新团队，热门连载漫画通常保持每周更新。对于已完结的漫画，我们提供漫画全集免费阅读。您可以在首页的"最新更新"板块查看当天更新的漫画列表，不错过任何精彩内容。',
  },
  {
    question: '手机和平板可以看漫画吗？',
    answer: '当然可以！汗汗漫画网采用响应式设计，完美适配手机、平板和电脑等各种设备。无论是在通勤路上用手机，还是在家用平板，都能获得流畅舒适的在线看漫画体验。',
  },
  {
    question: '如何收藏喜欢的漫画？',
    answer: '您可以在漫画详情页点击收藏按钮，将喜欢的漫画加入您的个人收藏夹。收藏后可以在个人中心随时查看更新状态，方便追更。所有收藏数据保存在您的浏览器中。',
  },
  {
    question: '漫画加载慢怎么办？',
    answer: '汗汗漫画网采用CDN加速技术，确保全国各地的用户都能获得流畅的访问速度。如果遇到加载慢的情况，建议检查网络连接或尝试切换网络环境。我们的技术团队持续优化服务器性能，为您提供流畅阅读体验。',
  },
  {
    question: '有漫画APP可以下载吗？',
    answer: '目前汗汗漫画网主要通过网页版提供服务。您可以在手机浏览器中直接访问我们的网站，添加到主屏幕即可获得类似APP的使用体验。我们也在积极筹备移动端应用的开发工作。',
  },
];

export const features = [
  {
    icon: 'ri-scroll-to-bottom-line',
    title: '下拉式连续阅读',
    description: '告别繁琐翻页，向下滚动即可连续阅读整部漫画，沉浸式体验如同观看动画般流畅自然。',
  },
  {
    icon: 'ri-global-line',
    title: '海量漫画大全',
    description: '汇集韩漫、日漫、国漫等主流类型，超过数千部漫画作品，每日持续更新最新热门漫画。',
  },
  {
    icon: 'ri-speed-line',
    title: '流畅不卡顿',
    description: '采用先进CDN加速和图片预加载技术，即使在移动网络下也能实现秒开漫画页面。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端适配',
    description: '完美兼容手机、平板、电脑，随时随地畅享漫画阅读乐趣，满足不同场景的阅读需求。',
  },
  {
    icon: 'ri-bookmark-line',
    title: '免费漫画全集',
    description: '所有漫画完全免费，已完结漫画免费全集畅读，连载漫画同步更新，无需任何付费。',
  },
  {
    icon: 'ri-search-line',
    title: '智能分类搜索',
    description: '按类型、地区、状态多维度筛选，快速找到心仪漫画。智能推荐系统为你发现更多好作品。',
  },
];

export const testimonials = [
  {
    name: '漫画迷小王',
    avatar: '',
    rating: 5,
    comment: '用了汗汗漫画快两年了，下拉式阅读真的太方便了！不用一直点翻页，看韩漫体验感超好。漫画资源也很全，基本上想看的都能找到。',
    date: '2026-07-15',
  },
  {
    name: '日漫爱好者玲玲',
    avatar: '',
    rating: 5,
    comment: '作为一个日漫死忠粉，汗汗漫画的日漫分类做得很细致。更新速度也很快，每周都能看到最新的连载。推荐给所有喜欢看漫画的朋友！',
    date: '2026-07-20',
  },
  {
    name: '国漫铁粉大刘',
    avatar: '',
    rating: 5,
    comment: '国漫这几年越做越好了，在汗汗漫画上发现了不少优质的国漫作品。免费漫画全集这个真的很良心，不用花钱就能看正版漫画。',
    date: '2026-07-25',
  },
  {
    name: '学生党小美',
    avatar: '',
    rating: 4,
    comment: '免费的漫画网站太适合学生了！平时零花钱不多，在这里可以免费看很多热门漫画。希望以后能出APP版本，那样就更方便了。',
    date: '2026-07-28',
  },
  {
    name: '上班族阿杰',
    avatar: '',
    rating: 5,
    comment: '通勤路上必刷汗汗漫画，下拉式阅读一只手就能操作，地铁上看很舒服。加载速度也快，基本不用等。强烈推荐上班族试试！',
    date: '2026-08-01',
  },
  {
    name: '老漫友三叔',
    avatar: '',
    rating: 5,
    comment: '看漫画二十多年了，汗汗漫画是我用过最舒服的在线漫画网站。分类清晰，画质高清，还有下拉连续阅读，老漫友表示很满意！',
    date: '2026-08-02',
  },
];